import { PkgWarehouse } from '@/api/user-package/types/UserPkg'

import { Chip } from './Chip'
import { WarehousePreview } from './WarehousePreview'

interface Props {
  warehouses: PkgWarehouse[]
  value: PkgWarehouse[]
  singleSelect?: boolean
  onChange: (warehouse: PkgWarehouse[]) => void
}
export const WarehouseFilter = ({ warehouses, value, singleSelect = false, onChange }: Props) => {
  const onToggleValue = (warehouse: PkgWarehouse) => {
    if (singleSelect) {
      onChange([warehouse])
    } else {
      if (value.includes(warehouse)) {
        onChange(value.filter(w => w !== warehouse))
      } else {
        onChange([...value, warehouse])
      }
    }
  }
  return (
    <div className='flex flex-wrap gap-2'>
      {warehouses.map(warehouse => (
        <Chip
          selected={value.includes(warehouse)}
          onSelect={() => onToggleValue(warehouse)}
          key={warehouse}
          icon={<WarehousePreview warehouse={warehouse} includeLabel />}
        />
      ))}
    </div>
  )
}
